module.exports = __webpack_public_path__ + "img/bank1.00cec531.jpg";